import { render, staticRenderFns } from "./ManageStudentProfile.vue?vue&type=template&id=dd5f40d8&"
import script from "./ManageStudentProfile.vue?vue&type=script&lang=js&"
export * from "./ManageStudentProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports